import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'
import Welcome from '../components/Welcome.vue'
import Link from '../components/link/Link.vue'
import Linkago from '../components/link/Linkago.vue'


Vue.use(VueRouter)

const routes = [
  { path:'/',redirect:'login'},
  { path:'/login',component: Login},
  { 
    path:'/home',
    component: Home,
    redirect: '/link',
    children:[{ path:'/welcome',component: Welcome},
    { path:'/link',component: Link},
    { path:'/linkago',component: Linkago}
  ]
  }
]

const router = new VueRouter({
  routes
})

//挂载路由导航守卫
router.beforeEach((to,from,next)=>{
  if(to.path === '/login') return next();
  const token = window.sessionStorage.getItem('token');
  if(!token) return next('/login')
  next()
})
export default router